import React from 'react';
export const IconUpload = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17.121",
  height: "20.183",
  viewBox: "0 0 17.121 20.183"
}, /*#__PURE__*/React.createElement("g", {
  id: "upload-file-2-svgrepo-com",
  transform: "translate(-4.25 -1.939)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7168",
  d: "M14.7,3H7.041A2.041,2.041,0,0,0,5,5.041v14.29a2.041,2.041,0,0,0,2.041,2.041h.51M14.7,3l5.614,5.741M14.7,3V7.721a1.021,1.021,0,0,0,1.021,1.021h4.593m0,0v10.59a2.041,2.041,0,0,1-2.041,2.041h-.51",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7169",
  d: "M12.052,21.166V13m0,0L14.6,15.552M12.052,13,9.5,15.552",
  transform: "translate(0.604 0.207)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5"
})));